import { defineMessages } from 'react-intl-next';

export const messages = defineMessages({
  imageAtl: {
    id: 'townsquare.onboarding.intro-popup.intro-popup-img-alt',
    description: 'Intro popup image alt text',
    defaultMessage: 'Intro popup image',
  },
  leftArrowIcon: {
    id: 'townsquare.onboarding.intro-popup.left-arrow-icon',
    description: 'Label for left arrow button icon in intro popup',
    defaultMessage: 'left-arrow-icon',
  },
  rightArrowIcon: {
    id: 'townsquare.onboarding.intro-popup.right-arrow-icon',
    description: 'Label for right arrow button icon in intro popup',
    defaultMessage: 'right-arrow-icon',
  },
  callToAction: {
    id: 'townsquare.onboarding.intro-popup.call-to-action',
    description: 'Text for the call to action button in intro popup',
    defaultMessage: 'Get full experience',
  },
  closeButton: {
    id: 'townsquare.onboarding.intro-popup.close-button',
    description: 'Text for close button in intro popup',
    defaultMessage: 'Close',
  },
  closeIcon: {
    id: 'townsquare.onboarding.intro-popup.close-icon',
    description: 'Label for close button icon in intro popup',
    defaultMessage: 'close-icon',
  },
  whatIsAtlasIcon: {
    id: 'townsquare.onboarding.intro-popup.what-is-atlas-icon',
    description: 'Label for what is atlas button icon in intro popup',
    defaultMessage: 'what-is-atlas-icon',
  },
  earlyAccessToGoalsAdminHeading: {
    id: 'townsquare.onboarding.intro-popup.early-access-to-goals-admin-heading',
    description: 'Early access to goals heading in intro popup',
    defaultMessage: 'Get early access to goals',
  },
  earlyAccessToGoalsAdminDescription: {
    id: 'townsquare.onboarding.intro-popup.early-access-to-goals-admin-description',
    description: 'Early access to goals description in intro popup',
    defaultMessage:
      'Goals help teams track their objectives, keeping everyone aligned and in the loop.  Goals will be available to everyone at no extra cost, but you can sign up now to get early access.',
  },
  earlyAccessToGoalsAdminButton: {
    id: 'townsquare.onboarding.intro-popup.early-access-to-goals-admin-button',
    description: 'Early access to goals button in intro popup',
    defaultMessage: 'Sign up now',
  },
  earlyAccessToGoalsEndUserHeading: {
    id: 'townsquare.onboarding.intro-popup.early-access-to-goals-end-user-heading',
    description: 'Early access to goals heading in intro popup',
    defaultMessage: 'Get better goal tracking early',
  },
  earlyAccessToGoalsEndUserDescription: {
    id: 'townsquare.onboarding.intro-popup.early-access-to-goals-end-user-description',
    description: 'Early access to goals description in intro popup',
    defaultMessage:
      'Goals help teams track progress on their objectives, keeping everyone aligned. Everyone will be able to use them when it’s released, but you can ask a site admin for early access.',
  },
  earlyAccessToGoalsEndUserButton: {
    id: 'townsquare.onboarding.intro-popup.early-access-to-goals-end-user-button',
    description: 'Early access to goals button in intro popup',
    defaultMessage: 'Send a request',
  },
  earlyAccessToGoalsPopupButton: {
    id: 'townsquare.onboarding.intro-popup.early-access-to-goals-popup-button',
    description: 'Early access to goals button in intro popup',
    defaultMessage: 'Get goals early',
  },
});
